/* ======== Hooks ========= */
import useProfile from "../hooks/useProfile";

import { isWeb } from "@helpers/platform";
import { useAppTheme } from "@hooks/useAppTheme";
import useClerkUser from "@hooks/useClerkUser";
import { useGlobalStore } from "@hooks/useGlobalStore";
import { Box, CustomSnackbar, ScrollContainer } from "@memorang/ui";
import { Card, Portal } from "react-native-paper";
/* ======== Components ========= */
import ProfileView from "../components/Profile/ProfileView";

const ProfileContainer = () => {
	const { profileDetails } = useProfile();

	const { headerStats, statsTabData } = profileDetails || {};
	const { username } = useClerkUser();

	const setShowAvatarUpdatedMessage = useGlobalStore(
		(state) => state.setShowAvatarUpdatedMessage,
	);

	const showAvatarUpdatedMessage = useGlobalStore(
		(state) => state.showAvatarUpdatedMessage,
	);

	const theme = useAppTheme();
	const Wrapper = isWeb ? Card : Box;
	return (
		<ScrollContainer
			style={{
				backgroundColor: theme.colors.background,
			}}
			contentContainerStyle={{
				flexGrow: 1,
				paddingBottom: 40,
			}}
			maxWidth="sm"
		>
			<Wrapper
				style={{
					marginTop: 16,
				}}
				height="100%"
				flexGrow={1}
			>
				<ProfileView
					avatar={""}
					name={username!}
					statsTabData={statsTabData}
					headerStats={headerStats}
				/>
			</Wrapper>
			{showAvatarUpdatedMessage && (
				<Portal>
					<CustomSnackbar
						message="Avatar updated successfully"
						duration={2000}
						visible
						handleDismiss={() => {
							setShowAvatarUpdatedMessage(false);
						}}
					/>
				</Portal>
			)}
		</ScrollContainer>
	);
};

export default ProfileContainer;
